import Icon from "@/components/icon";
import {
  EITAA_BASE_URL,
  SUPPORT_EITAA_USERNAME,
  SUPPORT_PHONE,
} from "@/utils/constant";

export default function EducatorsFooter() {
  const supportUsername = SUPPORT_EITAA_USERNAME.replace(/^@/, "");
  const supportChatLink = `${EITAA_BASE_URL}/${supportUsername}`;
  const supportPhone = SUPPORT_PHONE.replace(/[^\d+]/g, "");

  return (
    <footer className="mt-6 w-full bg-primary px-4 pb-8 pt-6 text-background">
      <div className="flex flex-col items-start gap-3">
        <img src="/svgs/logo-type.svg" alt="آموزیم" className="h-8 w-auto" />
        <span className="text-xs leading-5 text-white/70">
          برای انتشار دوره یا هر سوالی با ما در ارتباط باشید
        </span>
      </div>

      <div className="mt-5 flex flex-col gap-4">
        <a href={`tel:${supportPhone}`} className="flex items-center gap-3">
          <Icon name="support-phone" size={20} className="text-white/80" />
          <span className="text-sm text-white/80">شماره تماس</span>
          <span dir="ltr" className="mr-auto text-sm font-semibold">
            {SUPPORT_PHONE}
          </span>
        </a>

        <a
          href={supportChatLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3"
        >
          <Icon name="support" size={20} className="text-white/80" />
          <span className="text-sm text-white/80">آیدی پشتیبانی</span>
          <span dir="ltr" className="mr-auto text-sm font-semibold">
            @{supportUsername}
          </span>
        </a>
      </div>

      <p className="mt-6 border-t border-white/20 pt-4 text-center text-xs leading-6 text-white/60">
        © تمامی حقوق برای آموزیم محفوظ است.
      </p>
    </footer>
  );
}
